<!--
 * @Description: 适当性协议内容（风险不匹配，高风险，投资品种/期限不匹配提示）
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-10-21 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="comp-fund-protocol comp">
        <el-dialog
            class="prop"
            :visible.sync="centerDialogVisible"
            width="1000px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="closed"
        >
            <div slot="title" class="title-contain">
                <img
                    v-if="$cache.getCompanyInfoParam('10101007')"
                    :src="
                        $util.imgSrc({
                            fileCode: $cache.getCompanyInfoParam('10101007')
                        })
                    "
                    height="30"
                />
                <div class="title-bar">|</div>
                <div>销售适当性风险提示及声明</div>
            </div>
            <div class="protocol-con">
                <div v-for="(protocolItem, index) of protocol" :key="index">
                    <div class="risk-condition-contain">
                        <div v-if="protocolItem.id == '7'" class="protocol-title">
                            您正在购买
                            <span class="font-red">高风险</span>
                            产品
                        </div>
                        <div v-else class="img-flex">
                            <img src="@/assets/img/warn-tip.png" class="m-r-4" />
                            <div class="protocol-title">
                                {{ protocolItem.title }}
                            </div>
                        </div>
                        <div class="protocol-content" v-html="protocolItem.tipContent"></div>
                    </div>
                    <div class="row-bar"></div>
                </div>

                <div class="risk-common-contain">
                    <div class="img-flex">
                        <img src="@/assets/img/warn-ask.png" class="m-r-4" />
                        <div class="risk-common-title">风险告知</div>
                    </div>
                    <div class="risk-common-content1">
                        基金投资在获取利益的同时存在投资风险。为了保护您的合法权益，请在投资基金前认真阅读以下内容：
                    </div>
                    <div class="risk-common-content2">
                        <p>一、基金投资特有风险可能会导致本金亏损，包括但不限于事项如下：</p>
                        <p class="margin-t-13">
                            1、证券投资基金是一种长期投资工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。但基金不同于银行储蓄和债券等能够提供固定收益预期的金融工具，投资人购买基金，既可能按其持有份额分享基金投资所产生的收益，也可能承担基金投资所带来的本金亏损。
                        </p>
                        <p class="margin-t-13">
                            2、基金在投资运作过程中可能面临各种风险，可能会导致本金亏损。风险既包括市场风险，也包括基金自身的管理风险、技术风险和合规风险等。巨额赎回风险是开放式基金所特有的一种风险，即当单个交易日基金的净赎回申请超过基金总份额的百分之十时，投资人将可能无法及时赎回持有的全部基金份额。
                        </p>
                    </div>
                    <div class="risk-common-content3">
                        立即了解
                        <span v-on:click="toSdxText">《证券期货投资者适当性管理办法》</span>
                    </div>
                </div>
                <div class="row-bar"></div>
                <template v-if="agreeCheckFlag">
                    <div class="sale-suit-state">
                        <div class="img-flex">
                            <img src="@/assets/img/warn-tip-blue.png" class="m-r-4" />
                            <div class="sale-suit-state-title">销售适当性声明</div>
                        </div>
                        <div class="sale-suit-state-check">
                            <el-checkbox-group v-model="agreeCheck" class="check-box">
                                <el-checkbox style="white-space: wrap"></el-checkbox>
                            </el-checkbox-group>
                            <div class="check-text">
                                本人声明知悉并主动购买高于本人风险等级的此基金产品，并声明基金管理有限公司及其工作人员没有在基金销售过程中主动推介该基金产品或服务的信息。
                            </div>
                        </div>
                    </div>
                    <div class="row-bar"></div>
                </template>
            </div>

            <div slot="footer" class="dialog-footer align-c">
                <el-button class="close-btn" v-on:click="closed">取消</el-button>
                <el-button
                    type="primary"
                    :disabled="(agreeCheckFlag && !agreeCheck) || countNum > 0"
                    v-on:click="confirmCon"
                >
                    {{ btnMsg }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import commonApi from "@/api/common";

export default {
    name: "FundSdxDialog",
    props: {
        fund: {
            type: Object,
            required: true
        },
        sdxDialogVisible: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            protocol: [],
            centerDialogVisible: false,
            info: {},
            btnMsg: "我已悉知并确认",
            countNum: 0,
            agreeCheck: false,
            agreeCheckFlag: false,
            setTime: null
        };
    },
    watch: {
        sdxDialogVisible(val) {
            this.centerDialogVisible = val;
            if (val) {
                this.info = this.$cache.getUser();
                this.fundPopMes();
            }
        }
    },
    mounted() {},
    methods: {
        toSdxText() {
            const targetPath =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "/#/sdxtext";
            window.open(targetPath, "_blank");
        },
        btnDisabled() {
            this.countNum = 7;
            this.btnMsg = "我已悉知并确认交易(" + this.countNum + ")";
            this.setTime = setInterval(() => {
                this.countNum--;
                this.btnMsg = "我已悉知并确认交易(" + this.countNum + ")";
                if (this.countNum <= 0) {
                    clearInterval(this.setTime);
                    this.btnMsg = "我已悉知并确认";
                }
            }, 1000);
        },
        closed() {
            clearInterval(this.setTime);
            this.agreeCheck = false;
            this.countNum = 0;
            this.btnMsg = "我已悉知并确认";
            this.$emit("dialogClosed");
        },
        confirmCon() {
            clearInterval(this.setTime);
            this.agreeCheck = false;
            this.countNum = 0;
            this.btnMsg = "我已悉知并确认";
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.fund_sdx_agreement_agree,
                eventname: `协议同意`,
                content: JSON.stringify({
                    name: "销售适当性风险提示及声明",
                    content: this.btnMsg,
                    ...this.fund
                })
            });
            this.$emit("dialogContinue");
        },
        // 获取适当性提示信息类型
        fundPopMes() {
            this.protocol = [];
            // 投资品种或期限不匹配
            if (this.fund.fundmismatchflag === "1") {
                let protocolHtml = this.getMatchMsg();
                this.protocol.push({
                    id: "4",
                    title: "不匹配提示",
                    tipContent: protocolHtml
                });
            }
            // 高风险提示
            if (this.fund.highriskwarnflag === "1") {
                let protocolHtml = this.riskWarning();
                this.protocol.push({
                    id: "7",
                    title: "高风险提示",
                    tipContent: protocolHtml
                });
            }
            // 风险不匹配提示
            if (this.fund.riskmismatchflag === "1") {
                this.agreeCheckFlag = true;
                let protocolHtml = this.riskMismatch();
                this.protocol.push({
                    id: "6",
                    title: "风险提示",
                    tipContent: protocolHtml
                });
            } else {
                this.agreeCheckFlag = false;
            }

            if (this.protocol.length >= 1) {
                this.btnDisabled();
            }
        },
        // 获取期限文字
        getTerm(val) {
            if (val && val.trim() !== "") {
                const _arrTerm = val.split(",");
                let _TermTextArr = [];
                _arrTerm.forEach((arr) => {
                    if (arr) {
                        _TermTextArr.push(this.$cache.getDict("150071", arr));
                    }
                });
                return _TermTextArr.join("；");
            }
            return val;
        },
        // 获取投资品种文字
        getKind(val) {
            if (val && val.trim() !== "") {
                const _arrKind = val.split(",");
                let _kindTextArr = [];
                _arrKind.forEach((arr) => {
                    if (arr) {
                        _kindTextArr.push(this.$cache.getDict("150072", arr));
                    }
                });
                return _kindTextArr.join("；");
            }
            return val;
        },
        // 风险不匹配内容
        riskMismatch() {
            return (
                '您的风险评测结果是<span class="font-red">' +
                this.$cache.getDict("100017", this.info.risklevel) +
                "</span>，" +
                '所购买产品的风险等级为<span class="font-red">' +
                this.$cache.getDict("110143", this.fund.risklevel) +
                "</span>，" +
                "已超过您的风险承受能力，是否已知悉，并确认已经仔细阅读产品合同等法律文件，经审慎评估独立做出投资决策，自愿进行投资交易，并独立承担投资者风险。"
            );
        },
        // 高风险提示内容
        riskWarning() {
            return "该产品属于高风险产品，请确认已经仔细阅读产品合同等法律文件以了解产品风险";
        },
        // 绘制投资期限/品种不匹配内容
        getMatchMsg() {
            const fund = this.fund;
            let _matchFlagText = "";
            const userInvestTerm = this.getTerm(fund.userinvestterm);
            const userInvestKind = this.getKind(fund.userinvesttype);
            const fundInvestTerm = this.getTerm(fund.investterm);
            const fundInvestKind = this.getKind(fund.investkind);
            if (fund.typemismatchflag === "1" && fund.termmismatchflag === "1") {
                _matchFlagText =
                    '您的投资品种为<span class="font-red">' +
                    userInvestKind +
                    '</span>，投资期限为<span class="font-red">' +
                    userInvestTerm +
                    '</span>，所购买产品的投资品种为<span class="font-red">' +
                    fundInvestKind +
                    '</span>，投资期限为<span class="font-red">' +
                    fundInvestTerm +
                    "</span>。";
            } else if (fund.termmismatchflag === "1") {
                // 投资期限
                _matchFlagText =
                    '您的投资期限为<span class="font-red">' +
                    userInvestTerm +
                    '</span>，所购买产品的投资期限为<span class="font-red">' +
                    fundInvestTerm +
                    "</span>。";
            } else if (fund.typemismatchflag === "1") {
                // 投资品种
                _matchFlagText =
                    '您的投资品种为<span class="font-red">' +
                    userInvestKind +
                    '</span>，所购买产品的投资品种为<span class="font-red">' +
                    fundInvestKind +
                    "</span>。";
            }
            return (
                _matchFlagText +
                "产品信息与您的客户信息不匹配，请确认已经仔细阅读产品合同等法律文件以了解产品信息，确认继续购买该产品并自愿承担产品风险。"
            );
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.comp-fund-protocol {
    .title-contain {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: var(--color-text-primary);
        .title-bar {
            margin: 0 12px;
            color: var(--color-border-base);
        }
    }
    .protocol-con {
        .risk-condition-contain {
            padding: 26px 0;
            .protocol-title {
                font-size: 20px;
                font-weight: bold;
                color: var(--color-text-primary);
            }
            .protocol-content {
                font-size: 16px;
                font-weight: normal;
                color: var(--color-text-primary);
                margin: 18px 0 0;
            }
        }
        .risk-common-contain {
            padding-top: 26px;
            .risk-common-title {
                font-size: 20px;
                font-weight: bold;
                color: var(--color-text-primary);
            }
            .risk-common-content1 {
                font-size: 16px;
                font-weight: normal;
                color: var(--color-text-primary);
                margin: 18px 0 10px;
            }
            .risk-common-content2 {
                background: var(--bg-color-lightest);
                padding: 21px 15px;
                font-size: 16px;
                font-weight: normal;
                line-height: 26px;
                color: var(--color-text-regular);
                .margin-t-13 {
                    margin-top: 13px;
                }
            }
            .risk-common-content3 {
                margin: 14px 0 26px;
                font-size: 16px;
                font-weight: normal;
                color: var(--color-text-primary);
                span {
                    color: var(--color-redirect);
                    cursor: pointer;
                }
            }
        }
        .sale-suit-state {
            padding-top: 26px;
            .sale-suit-state-title {
                font-size: 20px;
                font-weight: bold;
                color: var(--color-redirect);
            }
            .sale-suit-state-check {
                margin-top: 18px;
                margin-bottom: 26px;
                display: flex;
                .check-box {
                    margin-right: 6px;
                }
                .check-text {
                    font-size: 16px;
                    font-weight: normal;
                    line-height: 26px;
                    color: var(--color-primary);
                }
            }
        }
    }
    .row-bar {
        width: 100%;
        height: 1px;
        background-color: var(--color-divided);
    }
    .dialog-footer {
        .close-btn {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--button-second-bg);
            border: var(--color-border-base);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: var(--color-text-regular);
        }
    }
    .font-red {
        color: var(--color-primary);
    }
    .img-flex {
        display: flex;
        align-items: center;
    }
    .m-r-4 {
        margin-right: 4px;
    }
}
</style>
